import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { messages } from '@fruitways/shared';
import { Banner, Button, PageHeader, TextField } from '@/components';
import { api } from '@/api/endpoints';
import { NetworkError } from '@/api/client';

export function ForgotPasswordScreen() {
  const nav = useNavigate();
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [failed, setFailed] = useState('');
  const [busy, setBusy] = useState(false);

  async function send() {
    const u = username.trim();
    if (!u) {
      setError(messages.login.usernameRequired);
      return;
    }
    setBusy(true);
    setFailed('');
    try {
      await api.auth.forgotPassword(u);
      setSent(true);
    } catch (err) {
      setFailed(err instanceof NetworkError ? messages.queue.sendFailed : messages.errors.generic);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="fw-frame" style={{ background: 'var(--color-surface)' }}>
      <PageHeader
        title={messages.forgot.title}
        onBack={() => nav('/login')}
        backLabel={messages.common.back}
      />
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--space-5)',
          padding: 'var(--space-5) var(--screen-padding-x)',
          background: 'var(--color-surface)',
        }}
      >
        <span style={{ font: 'var(--type-body)', color: 'var(--text-muted)' }}>
          {messages.forgot.intro}
        </span>
        <TextField
          label={messages.login.username}
          value={username}
          onChange={(v) => {
            setUsername(v);
            setError('');
          }}
          error={error}
          autoComplete="username"
          inputMode="email"
          autoCapitalize="none"
          required
        />
        {sent && (
          <Banner tone="info" rounded>
            {messages.forgot.sent}
          </Banner>
        )}
        {failed && (
          <Banner tone="error" rounded>
            {failed}
          </Banner>
        )}
      </div>
      <div
        style={{
          padding: '0 var(--screen-padding-x) var(--space-6)',
          background: 'var(--color-surface)',
        }}
      >
        <Button onClick={send} loading={busy}>
          {messages.forgot.send}
        </Button>
      </div>
    </div>
  );
}
